import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { ChatService } from '../../services/chat.service';
import { MessageTimestampComponent } from '../common/message-timestamp/message-timestamp.component';
import { MESSAGE_UNREAD_TEXT } from '../../utils/constants';

@Component({
  selector: 'app-dynamic-image',
  templateUrl: './dynamic-image.component.html',
  styleUrls: ['./dynamic-image.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MessageTimestampComponent,
  ],
  standalone: true,
})
export class DynamicImageComponent implements OnInit {
  @Input() input: any;
  @Input() isRead: boolean = false;

  config: any;
  messageText: string = '';
  messageUnreadText: string = MESSAGE_UNREAD_TEXT;

  constructor(private chatService: ChatService) {}

  get configs() {
    return this.chatService.configs;
  }

  ngOnInit() {
    this.config = this.input?.config;
    this.messageText = this.input?.message_text;
  }
}
